import { render, staticRenderFns } from "./mock-interview.vue?vue&type=template&id=31b3ab92"
import script from "./mock-interview.vue?vue&type=script&lang=js"
export * from "./mock-interview.vue?vue&type=script&lang=js"
import style0 from "./mock-interview.vue?vue&type=style&index=0&id=31b3ab92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports